import React, { useEffect, useRef } from "react"; //useState,
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import {
  Button,
  DialogContent,
  DialogActions,
  IconButton,
  Dialog,
  DialogTitle,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { useQuery, useMutation } from "@tanstack/react-query";
import * as api from "../../../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator } from "react-tabulator";
import { useTranslation } from "react-i18next";

import { format } from 'date-fns';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          className="float-end"
          size="large">
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const IssueInvoiceModal = ({
  handleClose,
  openIssue,
  addIssue,
  ItemGroupId,
  ...props
}) => {
  const { t } = useTranslation();
  ///console.log('dfdfdfdfdf====',ItemGroupId);
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const FacilityId = localStorage.getItem("FacilityId");
  const lan = localStorage.getItem("LangCode");
  const menukey = "receive";

  const tblIssueRefHolder = useRef({ table: null });
  const tblIssueRef = tblIssueRefHolder.current;

  let params = {
    action: "12345",
    menukey: menukey,
    ItemGroupId: ItemGroupId,
    FacilityId: FacilityId,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
  };

  const { isLoading, error, isError, data, refetch } = useQuery(
    [params],
    api.getReceivePickIssueInvoiceList
  );

  /*   const { data } = useQuery(["NonReceive"],
    api.getReceivePickIssueInvoiceList
  ); */

  const IssueModalColumns = [
    { title: "id", field: "id", visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      formatter: "rownum",
      width: 50,
      hozAlign: "center",
      headerHozAlign: "center",
      headerSort: false,
    }, { 
      title: t(DispensingLanguage[lan][menukey]["Issue Invoice No"]), 
    field: "TransactionNo",
    width: 140,
  },
    {
      title: t(DispensingLanguage[lan][menukey]["Issue Date"]),
      field: "TransactionDate",
      width: 100,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == null ? "" : format(new Date(value), 'dd/MM/yyyy');
      },
    },
    { 
      title: t(DispensingLanguage[lan][menukey]["Issued From"]), 
    field: "IssueFromFacility" 
  }, 
    { 
      title: t(DispensingLanguage[lan][menukey]["Order No"]), 
    field: "OrderNo" ,
    width: 140,
  },
    {
      title: t(DispensingLanguage[lan][menukey]["Order Date"]),
      field: "OrderDate",
      width: 100,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == null ? "" : format(new Date(value), 'dd/MM/yyyy');
      },
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Order Type"]),
      field: "OrderType",
      width: 100,
    },
  ];
  const IssueModaltDataItems = data?.map((item, index) => {
    return item;
  });
  const { mutate } = useMutation(api.saveReceivePickIssueInvoice, {
    onSuccess: (data) => {
      addIssue(data);
      //queryClient.getQueriesData('receive');
    },
  });
  const SaveSelectedIssue = () => {
    if (tblIssueRef.table.getSelectedData().length > 0)
      mutate(tblIssueRef.table.getSelectedData()[0].TransactionId);
  };

  useEffect(() => {
  }, []);

  return (
    <div>
      <BootstrapDialog
        onClose={() => handleClose("IssueInvoiceModal")}
        aria-labelledby="customized-dialog-title"
        open={openIssue}
        fullWidth={true}
        maxWidth="md"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => handleClose("IssueInvoiceModal")}
        >
          {DispensingLanguage[lan][menukey]["Issue Invoice List"]}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <ReactTabulator
            onRef={(r) => { tblIssueRef.table = r.current; }}
            options={{
              selectableRowsRangeMode: 'click',
              selectableRows: 1,
            }}
            columns={IssueModalColumns}
            data={IssueModaltDataItems}
            height="300px"
          />
        </DialogContent>
        <DialogActions>
          <Button
            className="me-2 float-start"
            variant="contained"
            color="primary"
            onClick={SaveSelectedIssue}
          >
            {DispensingLanguage[lan][menukey]["ADD"]}
          </Button>
          <Button
            autoFocus
            className="float-start"
            variant="contained"
            color="gray"
            onClick={() => handleClose("IssueInvoiceModal")}
          >
            {DispensingLanguage[lan][menukey]["CANCEL"]}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default IssueInvoiceModal;
